export class ColoringGameServer{
    static evaluateOnServer(exercise: any, correctSolution: any, userSolution: any): Evaluated {
        return { "success": false, "solution": [], "successPercent": 0 };
    }
}